
import { Route, Routes } from 'react-router-dom'
import { Suspense } from 'react'
import { lazyWithRecovery } from '../../utils/lazyWithRecovery'
import { ErrorsLayout } from './ErrorsLayout'
import SplashScreen from '../../components/SplashScreen/SplashScreen'

const Error404 = lazyWithRecovery(() => import('../../modules/errors/components/Error404'))
const Error401 = lazyWithRecovery(() => import('../../modules/errors/components/Error401'))
const Error403 = lazyWithRecovery(() => import('../../modules/errors/components/Error403'))
const Error500 = lazyWithRecovery(() => import('../../modules/errors/components/Error500'))

const ErrorsPage = () => (
  <Suspense fallback={<SplashScreen />}>
    <Routes>
      <Route element={<ErrorsLayout />}>
        <Route path='404' element={<Error404 />} />
        <Route path='500' element={<Error500 errorId={''} />} />
        <Route path='401' element={<Error401 />} />
        <Route path='403' element={<Error403 />} />
        <Route index element={<Error404 />} />
      </Route>
    </Routes>
  </Suspense>
)

export { ErrorsPage }
